<dx-box
    #violationNoticesBox
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-grid-container"
    [elementAttr]="{ id: 'violationNoticesBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <cc-data-grid-features
            #gridFeatures
            [stateConfig]="{ storageKey: 'VIOLATION_NOTICES_SEARCH_GRID' }"
            [dataSource]="violationNotices"
        >
            <dx-data-grid width="100%" height="100%" [dataSource]="violationNotices">
                <dxo-search-panel [text]="searchText"></dxo-search-panel>
                <dxi-column dataField="violationId" dataType="number" caption="Violation ID"></dxi-column>
                <dxi-column dataField="violationNoticeId" dataType="number" caption="Notice ID"></dxi-column>
                <dxi-column dataField="combinedOwner" dataType="string" caption="Combined Owner"></dxi-column>
                <dxi-column
                    dataField="accountNumber"
                    dataType="string"
                    caption="Account Number"
                    cellTemplate="customerTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="community"
                    dataType="string"
                    caption="Community"
                    cellTemplate="communityTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="propertyAddress"
                    dataType="string"
                    caption="Property Address"
                    cellTemplate="customerTemplate"
                ></dxi-column>
                <dxi-column dataField="category" dataType="string" caption="Category"></dxi-column>
                <dxi-column dataField="subCategory" dataType="string" caption="Sub-Category"></dxi-column>
                <dxi-column dataField="location" dataType="string" caption="Location"></dxi-column>
                <dxi-column dataField="status" dataType="string" caption="Status"></dxi-column>
                <dxi-column dataField="violationNoticeType" dataType="string" caption="Notice Type"></dxi-column>
                <dxi-column dataField="violationStatus" dataType="string" caption="Violation Status"></dxi-column>
                <dxi-column
                    dataField="noticeUrl"
                    dataType="string"
                    caption="Notices"
                    alignment="center"
                    [width]="60"
                    cellTemplate="noticesTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="inspectDate"
                    dataType="date"
                    caption="Inspect Date"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column dataField="inspectStatus" dataType="string" caption="Inspect Status"></dxi-column>
                <dxi-column
                    dataField="inspectorDisplayText"
                    dataType="string"
                    caption="Inspector"
                    cellTemplate="inspectorBioTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="regarding"
                    dataType="string"
                    caption="Regarding"
                    [width]="150"
                    cellTemplate="regardingTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="preFineOverride"
                    dataType="boolean"
                    caption="Pre-Fine Override"
                    cellTemplate="isActiveTempalte"
                ></dxi-column>
                <dxi-column
                    dataField="reviewRequest"
                    dataType="boolean"
                    caption="Review Request"
                    cellTemplate="isActiveTempalte"
                ></dxi-column>
                <dxi-column
                    dataField="reviewDate"
                    dataType="date"
                    caption="Review Date"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column dataField="closedReason" dataType="string" caption="Closed Reason"></dxi-column>
                <dxi-column
                    dataField="closedByDisplayText"
                    dataType="string"
                    caption="Closed By"
                    cellTemplate="closedByUserTemplate"
                ></dxi-column>

                <div *dxTemplate="let row of 'closedByUserTemplate'">
                    <app-user-bio-link
                        [user]="row.data.closedBy"
                        [communityId]="row.data.communityId"
                    ></app-user-bio-link>
                </div>

                <div *dxTemplate="let row of 'inspectorBioTemplate'">
                    <app-user-bio-link
                        [user]="row.data.inspector"
                        [communityId]="row.data.communityId"
                    ></app-user-bio-link>
                </div>

                <div *dxTemplate="let row of 'communityTemplate'">
                    <app-property-community-link
                        [communityId]="row.data.communityId"
                        [displayText]="row.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let row of 'customerTemplate'">
                    <app-property-community-link
                        [communityId]="row.data.communityId"
                        [customerId]="row.data.accountNumber"
                        [displayText]="row.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let row of 'noticesTemplate'" class="status-cell-template">
                    <i
                        class="cc-1-5x fas fa-file-pdf cc-icon-pdf icon-content cc-hyperlink icon-data-content"
                        (click)="downloadFile(row.data)"
                    ></i>
                </div>

                <div *dxTemplate="let row of 'isActiveTempalte'" class="status-cell-template">
                    <i *ngIf="row.value" class="cc-green-icon cc-1-5x" [ngClass]="iconCheck" aria-hidden="true"></i>
                    <i *ngIf="!row.value" class="cc-red-icon cc-1-5x" [ngClass]="iconClose" aria-hidden="true"></i>
                </div>

                <div *dxTemplate="let row of 'regardingTemplate'">
                    <app-hyperlink-creator
                        cssClass="regarding-text"
                        [displayText]="row.value"
                        (onLinkClick)="toggleRegarding(row)"
                    ></app-hyperlink-creator>

                    <div *ngIf="row.rowIndex === gridRowIndex && showRegarding" class="regarding-long-text">
                        {{ row.value }}
                    </div>
                </div>

                <dxo-summary>
                    <dxi-group-item
                        column="violationId"
                        summaryType="count"
                        displayFormat="Count = {0}"
                    ></dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#violationNoticesBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
